import React from 'react';
import { Star, CheckCircle2, ArrowRight } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';

export default function Hero() {
  const [zoomed, setZoomed] = React.useState(false);
  const { t } = useLanguage();

  React.useEffect(() => {
    const timer = setTimeout(() => {
      setZoomed(true);
    }, 100);
    return () => clearTimeout(timer);
  }, []);

  const scrollToForm = () => {
    const element = document.getElementById('vurdering-form');
    if (element) {
      const offset = 80;
      const bodyRect = document.body.getBoundingClientRect().top;
      const elementRect = element.getBoundingClientRect().top;
      const elementPosition = elementRect - bodyRect;
      const offsetPosition = elementPosition - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <section className="relative w-full overflow-hidden bg-slate-950">
      {/* Full-width Hero Image Background Container */}
      <div className="relative min-h-[65vh] md:min-h-[75vh] lg:min-h-[80vh] flex items-center justify-center pt-36 pb-16 sm:pt-40 md:pt-28 md:pb-20 lg:pt-40 lg:pb-16">
          {/* Background Image */}
          <div className="absolute inset-0 w-full h-full overflow-hidden">
            <img 
              src="https://assets.auxodev.dk/cdn-cgi/image/width=1600,quality=85,format=auto/assets/5bfde40d-44ae-4b1e-9e89-bf8f3817c44f/703131686-122122485417173180-7723105231297340084-n-3.jpg" 
              alt="Premium bil" 
              className="w-full h-full object-cover object-center transition-transform duration-[3000ms] ease-out"
              style={{ transform: `scaleX(-1) scale(${zoomed ? 1.1 : 1})` }}
            />
            {/* Dark overlay for maximum readability - darker on the left, transparent on the right */}
            <div className="absolute inset-0 bg-gradient-to-l from-slate-950 via-slate-950/80 to-transparent" />
          </div>

        {/* Centered Content Overlay */}
        <div className="relative z-10 max-w-7xl mx-auto px-6 w-full text-right flex flex-col items-end space-y-8">
          
          {/* Google Trust Badge */}
          <div className="inline-flex items-center gap-2.5 py-2">
            <div className="flex items-center gap-0.5 text-[#f6bb06]">
              {[...Array(5)].map((_, i) => (
                <Star key={i} className="h-4 w-4 fill-current" />
              ))}
            </div>
            <span className="text-xs font-semibold text-white">
              {t('hero.rating')}
            </span>
          </div>

          {/* Heading */}
          <h1 className="text-2xl sm:text-5xl md:text-6xl lg:text-7xl font-black italic tracking-tight text-white leading-[1.1] uppercase max-w-5xl drop-shadow-md">
            {t('hero.title')}
          </h1>



          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row items-stretch sm:items-center justify-end gap-4 w-full sm:w-auto">
            <button
              onClick={scrollToForm}
              className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-6 py-3 sm:px-8 sm:py-4 rounded-none bg-[#76eeda] text-black font-bold text-sm sm:text-base shadow-lg shadow-[#76eeda]/20 transition-all cursor-pointer"
            >
              <span className="flex items-center gap-2">
                {t('hero.cta_valuation')}
                <ArrowRight className="h-4 w-4 sm:h-5 sm:w-5" />
              </span>
            </button>
            <button
              onClick={() => {
                const el = document.getElementById('saadan-fungerer-det');
                if (el) el.scrollIntoView({ behavior: 'smooth' });
              }}
              className="w-full sm:w-auto inline-flex items-center justify-center px-6 py-3 sm:px-8 sm:py-4 rounded-none bg-white text-slate-900 font-semibold text-sm sm:text-base transition-all cursor-pointer"
            >
              {t('hero.cta_how')}
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
